<template>
  <section id="features" class="py-5 bg-light">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="fw-bold text-dark">Características Principales de Medicynia</h2>
        <p class="mt-2 fs-5 text-muted">Descubre todas las funcionalidades diseñadas para optimizar tu práctica médica.</p>
      </div>
      <div class="row g-4 justify-content-center">
        <!-- Feature 1: Gestión de Personal Médico -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-person-vcard fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Gestión de Personal Médico</h5>
              <p class="card-text text-muted small">Registra y administra tu perfil, especialidad, contacto, tarifas por consulta, disponibilidad semanal y control de usuarios.</p>
            </div>
          </div>
        </div>
        <!-- Feature 2: Gestión de Pacientes -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-people fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Gestión de Pacientes</h5>
              <p class="card-text text-muted small">Registra datos completos (nombre, género, nacimiento), contacto, seguridad social y vincula su historial clínico, consultas, notas y documentos.</p>
            </div>
          </div>
        </div>
        <!-- Feature 3: Agenda y Calendario de Citas -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-calendar-week fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Agenda y Citas Médicas</h5>
              <p class="card-text text-muted small">Configura horarios, tipos de consulta (consultorio, virtual, domicilio, etc.), duración, evita empalmes, gestiona estatus (agendada, confirmada, cancelada) y confirmaciones.</p>
            </div>
          </div>
        </div>
        <!-- Feature 4: Registro de Consultas Médicas -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-heart-pulse fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Registro de Consultas Médicas</h5>
              <p class="card-text text-muted small">Documenta motivo de visita, diagnóstico, pronóstico, plan de tratamiento y relaciona con notas, archivos y consentimientos. Registra fecha y duración.</p>
            </div>
          </div>
        </div>
        <!-- Feature 5: Notas Médicas Estructuradas (NOM-004) -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-file-earmark-medical fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Notas Médicas (NOM-004)</h5>
              <p class="card-text text-muted small">Genera notas (consulta externa, evolución, interconsulta, urgencias, egreso) conforme a la NOM-004, con campos clínicos, edición limitada al día y opción de firma digital y PDF.</p>
            </div>
          </div>
        </div>
        <!-- Feature 6: Antecedentes Médicos -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-activity fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Antecedentes Detallados</h5>
              <p class="card-text text-muted small">Registra historial por tipo (heredo-familiares, personales, quirúrgicos, alergias), enfermedad, fecha, severidad, tratamiento actual y observaciones.</p>
            </div>
          </div>
        </div>
        <!-- Feature 7: Prescripción de Tratamientos -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-capsule fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Prescripción de Tratamientos</h5>
              <p class="card-text text-muted small">Define tu inventario de medicamentos personalizado, dosis, frecuencia, duración y observaciones clínicas para cada tratamiento, vinculado a recetas o seguimiento.</p>
            </div>
          </div>
        </div>
        <!-- Feature 8: Archivos Adjuntos -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-paperclip fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Archivos Adjuntos</h5>
              <p class="card-text text-muted small">Sube y visualiza documentos clínicos (resultados de laboratorio, rayos X, imágenes) vinculados a consultas específicas. Descarga o visualiza directamente.</p>
            </div>
          </div>
        </div>
        <!-- Feature 9: Consentimientos Informados -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-shield-check fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Consentimientos Digitales (NOM-004)</h5>
              <p class="card-text text-muted small">Genera y resguarda consentimientos digitales (formato IMSS/NOM-004) con datos del paciente, procedimiento, riesgos, beneficios y firmas (paciente, médico, testigo) en PDF.</p>
            </div>
          </div>
        </div>
         <!-- Feature 10: Registro y Gráficas de Estudios Clínicos -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-graph-up fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Estudios Clínicos y Gráficas</h5>
              <p class="card-text text-muted small">Registra indicadores cuantitativos (glucosa, presión, colesterol) definidos por el médico, asociados a consultas. Próximamente con visualización gráfica.</p>
            </div>
          </div>
        </div>
         <!-- Feature 11: Control de Precios por Tipo de Consulta -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-tags fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Control de Precios</h5>
              <p class="card-text text-muted small">Establece tarifas personalizadas según modalidad de consulta (consultorio, domicilio, virtual, hospital, otra) para un resumen de ingresos simple.</p>
            </div>
          </div>
        </div>
         <!-- Feature 12: Auditoría y Seguridad -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-fingerprint fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Auditoría y Seguridad</h5>
              <p class="card-text text-muted small">Registro automático de acciones sensibles (inserciones, ediciones, eliminaciones) con fecha y usuario, para trazabilidad, cumplimiento y protección legal.</p>
            </div>
          </div>
        </div>
         <!-- Feature 13: Firma Digital (Opcional) -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-vector-pen fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Firma Digital (Opcional)</h5>
              <p class="card-text text-muted small">Capacidad de integrar firma autográfa digitalizada del médico en notas, consentimientos y recetas.</p>
            </div>
          </div>
        </div>
         <!-- Feature 15: Panel Administrativo -->
        <div class="col-lg-4 col-md-6">
          <div class="card h-100 shadow-sm border-0">
            <div class="card-body text-center p-4">
              <i class="bi bi-speedometer2 fs-1 text-primary mb-3"></i>
              <h5 class="card-title fw-semibold text-dark mb-3">Panel de Control Médico</h5>
              <p class="card-text text-muted small">Dashboard para consultar agenda, pacientes activos, últimas consultas, generar notas, cargar archivos, editar tarifas y visualizar alertas clínicas.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection'
}
</script>

<style scoped>
.card {
  transition: transform 0.2s ease-in-out;
}
.card:hover {
  transform: translateY(-5px);
}

/* Force icon color */
.card-body i.text-primary {
  color: var(--eb-primary) !important; /* Use custom variable and !important */
}
.card-text.small {
  font-size: 0.85rem; /* Adjust size as needed */
  line-height: 1.4;
}
</style>
